<template>
	<div>
		<div class="d-flex vef">
			<div class="mr-auto"><img src="/Images/VEF_Text.jpg" alt="banner"></div>
			<div class="top-menu">
				<b-nav>
					<b-nav-item v-for="p in items" :key="p.id" :to="p.link">{{p.name}}</b-nav-item>
				</b-nav>
			</div>
		</div>
		<div class="pic"><img src="/Images/VEF2.jpg" alt="banner"></div>
	</div>
</template>

<script>
    export default {
		name: 'Banner',
		props: [
			'items'
		],
	}
</script>

<style scoped>
	.vef {
		background-color: #02913F;
	}
	.pic img{
		width: 100%;
	}
	.top-menu {
		
		padding-right: 35px;
	}
	.top-menu a.nav-link {
		color: #fff;
		
	}
</style>